import { render, staticRenderFns } from "./PurchaseConfirmation.vue?vue&type=template&id=200e51e2&scoped=true&"
import script from "./PurchaseConfirmation.vue?vue&type=script&lang=js&"
export * from "./PurchaseConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseConfirmation.vue?vue&type=style&index=0&id=200e51e2&scoped=true&lang=css&"
import style1 from "./PurchaseConfirmation.vue?vue&type=style&index=1&id=200e51e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200e51e2",
  null
  
)

export default component.exports